import { alpha } from "@mui/system";

const styles = (theme) => ({
  boxModal: {
    position: "absolute",
    borderRadius: "16px",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: " 90%",
    maxWidth: "1000px",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  },
  boxTitle: {
    width: "100%",
    margin: "20px 0",
  },
  containerButtonNewPergunta: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginBottom: "10px",
  },

  boxPerguntas: {
    width: "100%",
    margin: "10px 0",
    minHeight: "400px",
    height: "34vh",
    overflow: "hidden",
    overflowY: "auto",
  },
  containerButtonIcons: {
    display: "flex",
    gap: 1,
    flexDirection: "column",
  },
  conatinerPreVisualizacao: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  boxMainPerguntas: {
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
    p: 2,
    borderRadius: "16px",
  },
  containerButton: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: 1,
    marginTop: "10px",
  },
  boxAnswer: {
    mb: 1,
    display: "flex",
    alignItems: "center",
  },
});

export default styles;
